import { render, staticRenderFns } from "./GadgetFrame.vue?vue&type=template&id=eba8d350&scoped=true&"
import script from "./GadgetFrame.vue?vue&type=script&lang=ts&"
export * from "./GadgetFrame.vue?vue&type=script&lang=ts&"
import style0 from "./GadgetFrame.vue?vue&type=style&index=0&id=eba8d350&lang=scss&scoped=true&"
import style1 from "./GadgetFrame.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba8d350",
  null
  
)

export default component.exports